import React, { useMemo } from "react";
import { ReactifyChartColors } from "Util/ReactifyChartColors";

const colors = ReactifyChartColors();

import Chart from "react-apexcharts";
import type { ApexOptions } from "apexcharts";

function MixedChart() {
  const { options, series } = useMemo(
    () => ({
      options: {
        colors: [
          colors.ReactifyChartColor1,
          colors.ReactifyChartColor2,
          colors.ReactifyChartColor3
        ],
        dataLabels: {
          enabled: false
        },

        stroke: {
          width: [1, 1, 4]
        },
        title: {
          text: "Stock Analysis",
          align: "left",
          offsetX: 110
        },
        xaxis: {
          categories: [2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019]
        },
        yaxis: [
          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: false,
              color: colors.ReactifyChartColor1
            },
            labels: {
              style: {
                color: colors.ReactifyChartColor1
              }
            },
            tooltip: {
              enabled: true
            }
          }
        ],
        tooltip: {
          fixed: {
            enabled: true,
            position: "topLeft",
            offsetY: 30,
            offsetX: 60
          }
        },
        legend: {
          horizontalAlign: "left",
          offsetX: 40
        }
      },
      series: [
        {
          name: "Income",
          type: "column",
          data: [10, 19, 20, 36, 44, 40, 30, 21]
        },
        {
          name: "Cashflow",
          type: "column",
          data: [20, 29, 37, 36, 44, 45, 50, 58]
        },
        {
          name: "Revenue",
          type: "line",
          data: [20, 29, 37, 36, 44, 45, 50, 58]
        }
      ]
    }),
    []
  );

  return (
    <Chart
      options={options as unknown as ApexOptions}
      series={series}
      type="line"
      width="100%"
    />
  );
}

export default MixedChart;
